import { ConnectResult, createPromiseClient } from '@/connect';
import {
  ListChildOrdersResponse,
  VenueService,
} from '@/connect/gen/modules/apiengine/services/venue/venue_pb';

export const venueService = new (class {
  public readonly promiseClient = createPromiseClient(VenueService);

  public async listChildOrders(parentId: string): Promise<ConnectResult<ListChildOrdersResponse>> {
    const result = await this.promiseClient.listChildOrders({ parentId });
    return result as ConnectResult<ListChildOrdersResponse>;
  }
})();
